export default {
  1: {
    default: true,
    formName: 'life',
    formFromUrl: '1',
    variantFromUrl: '1',
  },
};
